import { Box, useMediaQuery } from '@mediahuis/chameleon-react';
import { RESPONSIVE_GRID_SCREEN_SIZE } from "./ResponsiveGrid.types.js";
import { jsx as _jsx } from "react/jsx-runtime";
const defaultRepeatCount = 'auto-fit';
const defaultTrackSize = 'minmax(0, 1fr)';
const calculateRepeatValue = (columns, screenSize) => {
  let repeatCount = defaultRepeatCount;
  let trackSize = defaultTrackSize;
  if (screenSize === RESPONSIVE_GRID_SCREEN_SIZE.xs && columns.xs) {
    if (columns.xs.count) {
      repeatCount = columns.xs.count;
    }
    if (columns.xs.width) {
      trackSize = columns.xs.width;
    }
  }
  if (screenSize === RESPONSIVE_GRID_SCREEN_SIZE.sm && columns.sm) {
    if (columns.sm.count) {
      repeatCount = columns.sm.count;
    }
    if (columns.sm.width) {
      trackSize = columns.sm.width;
    }
  }
  if (screenSize === RESPONSIVE_GRID_SCREEN_SIZE.md && columns.md) {
    if (columns.md.count) {
      repeatCount = columns.md.count;
    }
    if (columns.md.width) {
      trackSize = columns.md.width;
    }
  }
  if (screenSize === RESPONSIVE_GRID_SCREEN_SIZE.lg && columns.lg) {
    if (columns.lg.count) {
      repeatCount = columns.lg.count;
    }
    if (columns.lg.width) {
      trackSize = columns.lg.width;
    }
  }
  if (screenSize === RESPONSIVE_GRID_SCREEN_SIZE.xl && columns.xl) {
    if (columns.xl.count) {
      repeatCount = columns.xl.count;
    }
    if (columns.xl.width) {
      trackSize = columns.xl.width;
    }
  }
  return `repeat(${repeatCount}, ${trackSize})`;
};
const ResponsiveGrid = _ref => {
  let {
    className,
    columns,
    gap,
    justifyContent,
    testId,
    render
  } = _ref;
  const screenSize = useMediaQuery(['xs', 'sm', 'md', 'lg', 'xl']);
  return /*#__PURE__*/_jsx(Box, {
    className: className,
    "data-testid": testId,
    display: "grid",
    style: {
      gap,
      gridTemplateColumns: calculateRepeatValue(columns, screenSize),
      justifyContent
    },
    width: "full",
    children: render(screenSize)
  });
};
export default ResponsiveGrid;